import React from "react";
import { Link } from "react-router-dom";
import { BSBtnDropdown } from "traec-react/utils/bootstrap/";
import { SidebarDropdown } from "../company/tree/treeRow";
import { confirmDelete } from "traec-react/utils/sweetalert";
import { ErrorBoundary } from "storybook-dashboard/errors";

import { MiniErrorBoundary } from "AppSrc/project/report/error";
import { workPackageFields } from "AppSrc/project/wptree/form";

import { setAndShowModal } from "AppSrc/utils/modal";
import { setNewWorkPackageFields, nestDunderKeys, getTerm } from "./utils";
import { SetMetaDataFields } from "AppSrc/forms/meta";
import { InviteReportersModal, AddReportingPackageModal } from "./projectRow";
import { ProjectPermission } from "../project/utils/permissions";
import { useLocalStorage } from "AppSrc/utils/hooks";
import { Hide } from "storybook-dashboard/utils";
import { Modal, useModal } from "storybook-dashboard/components/modal";
import useApi, { doFetch } from "storybook-dashboard/utils/fetching";
import Im from "immutable";

import { Indent } from "./indent";
import { useTreeContext } from "./context";
const counter = { row: 0 };

const deleteWorkPackage = (e, { ref, onSuccess }) => {
  e.preventDefault();
  let refName = ref?.get("name");
  const trackerId = ref?.get("tracker");
  const refId = ref?.get("uid");

  if (!trackerId || !refId) {
    console.error("Cannot delete work package, missing trackerId or refId", trackerId, refId);
  }

  confirmDelete({
    text: `This will delete the Reporting Package: ${refName}.\n\n Are you sure you would like to proceed?`,
    onConfirm: () => {
      doFetch(`/api/tracker/${trackerId}/ref/${refId}/`, "DELETE")
        .then(() => {
          onSuccess();
        })
        .catch((error) => {
          console.error("Error deleting work package", error);
        });
    },
  });
};

function SubRefs(props) {
  let { projectId, tracker, cref, subRefs, showMenu, menuOnSelectedOnly, initDepth, tenant_meta, userPermissions } =
    props;

  if (!subRefs || !subRefs.size) {
    return null;
  }

  return subRefs
    .filter((i) => i)
    .sortBy((i) => i.get("name"))
    .map((item, i) => (
      <WorkPackageRow
        key={i}
        rootRef={item}
        initDepth={initDepth}
        projectId={projectId}
        tracker={tracker}
        cref={cref}
        showMenu={showMenu}
        menuOnSelectedOnly={menuOnSelectedOnly}
        tenant_meta={tenant_meta}
        userPermissions={userPermissions}
      />
    ));
}

const addSubReportingPackage = (props) => {
  let { trackerId, rootRefId: refId, commitId, treeId } = props;

  let url = `/api/tracker/${trackerId}/ref/${refId}/tree/${treeId}/branch/`;
  doFetch(url, "POST", {
    ...nestDunderKeys({ ...body, latest_commit__comment: "." }),
    ref_name: body.name || "master",
    from_commit: commitId,
  }).then((response) => location.reload());
};

export function AddSubReportingPackageModal() {
  return (
    <Modal title={`Add a Reporting Package`}>
      <div className="row">
        <div className="form-group col">
          <label htmlFor="name">Name</label>
          <input className="form-control" id="name" name="name" />
        </div>
      </div>
    </Modal>
  );
}

const editMetaData = (props) => {
  let { trackerId, commitId, rootRefId: refId, rootRef: cref } = props;
  let modalId = `ReportingPackageModal_${refId}`;

  console.log("Showing Reporting Package meta-data", cref?.toJS());

  setAndShowModal(
    modalId,
    {
      title: `${getTerm("Reporting Package", props)} meta-data`,
      body: (
        <SetMetaDataFields
          hideAdmin={true}
          saveMetaFetchProps={{
            handler: "tracker_ref_commit",
            method: "patch",
            params: {
              trackerId,
              refId,
              commitId,
            },
          }}
          metaJson={cref.getInPath("latest_commit.meta_json")}
        />
      ),
    },
    true
  );
};

export function WPDropDownMenu(props) {
  const { triggerRefs } = useTreeContext();
  const { _ref: ref } = props;
  const { setModal } = useModal();
  console.log("WPDropDownMenu", ref?.toJS());
  const refId = ref?.get("uid");
  const projectId = ref?.get("project");

  let rp_term = getTerm("Reporting Package", Im.Map());

  let links = [
    {
      name: `Add a sub-${rp_term}`,
      onClick: (e) => setModal(<AddReportingPackageModal {...{ projectId, refId, onSuccess: triggerRefs }} />),
    },
    {
      name: "Settings",
      linkTo: `/project/${projectId?.substring(0, 8)}/wpack/${refId?.substring(0, 8)}/details`,
    },
    {
      name: `${rp_term} info`,
      onClick: (e) => editMetaData(props),
    },
    { name: "Invite reporters", onClick: (e) => setModal(<InviteReportersModal {...{ projectId, refId }} />) },
    {},
    { name: "Delete", onClick: (e) => deleteWorkPackage(e, { ref, onSuccess: triggerRefs }) },
  ];

  return (
    <MiniErrorBoundary>
      <SidebarDropdown dropdownItems={links} />
    </MiniErrorBoundary>
  );
}

export default function WorkPackageRow(props) {
  const {
    showMenu,
    projectId,
    rootRef,
    includeRoot = true,
    alternateBgColor = true,
    menuOnSelectedOnly = false,
    initDepth = 0,
    isAllowedToSee,
  } = props;

  const refId = rootRef?.get("uid");
  const [expanded, setExpanded] = useLocalStorage(`sidebar-${refId}`);

  const isRoot = false;
  const isCurrent = false;

  console.log(`Sidebar render ${rootRef?.get("name")}`, isAllowedToSee);
  if (!rootRef || (!isRoot && !isAllowedToSee)) {
    return null;
  }

  let depth = rootRef.get("depth");
  let rootTreeName = rootRef.get("name");

  // Skip the special "conversion_factors" branch
  if (rootTreeName == "conversion_factors") {
    return "";
  }

  const _projectId = projectId.substring(0, 8);
  const _refId = rootRef.get("uid").substring(0, 8);

  rootTreeName = isRoot ? <b>Project Home</b> : rootTreeName;
  let rowClass = isCurrent ? "tree-row-active" : "";
  let linkLoc = isRoot ? `/project/${_projectId}` : `/project/${_projectId}/wpack/${_refId}`;

  let rowNum = counter.row++;
  let styleObj = showMenu && alternateBgColor ? { backgroundColor: (rowNum + 1) % 2 && !rowClass ? "#ddd" : "" } : {};
  styleObj = { display: "inline-block", verticalAlign: "middle" };

  let shouldRender = rootRef.get("project") === projectId;

  let doRender = true;
  if (!includeRoot && isRoot) {
    doRender = false;
  }

  // Whether we should show the dropdown menu
  let _showMenu = showMenu;
  if (menuOnSelectedOnly) {
    _showMenu = isCurrent;
  }

  return (
    <ErrorBoundary>
      {shouldRender && doRender ? (
        <div className={`row m-0 p-0 ${rowClass}`}>
          <Indent depth={initDepth + depth - 1} expanded={false} />
          <div className={`m-0 p-0 col`} style={styleObj}>
            <Link to={linkLoc}>
              <i>{rootTreeName}</i>
            </Link>
            <Hide when={!_showMenu}>
              <ProjectPermission projectId={projectId} requiresAdmin={true}>
                <WPDropDownMenu />
              </ProjectPermission>
            </Hide>
          </div>
        </div>
      ) : null}

      <Hide when={!_showMenu}>
        <SubRefs />
      </Hide>
    </ErrorBoundary>
  );
}

const isAllowed = (commit, projectDisciplines, userPermissions) => {
  // If the user is a project admin then return true
  if (userPermissions?.get("is_admin")) {
    return true;
  }

  // Get the project disciplines in a map
  let projectBaseDisciplineMap = projectDisciplines?.reduce((obj, i) => obj.set(i.get("base_uid"), i), Im.Map());

  // Check if we are the responsible user
  let disciplineId = commit.get("discipline");
  let projectDiscipline = projectBaseDisciplineMap.get(disciplineId);

  // If we don't have a project discipline then return false (only superusers and project admins could view this)
  if (!projectDiscipline) {
    return false;
  }

  // Check if the user is responsible
  if (userPermissions?.get("projectDisciplineIds")?.contains(projectDiscipline?.get("uid"))) {
    return true;
  }

  // Check if the user is an approver or responsible
  let approverId = projectDiscipline.get("approver");
  if (userPermissions?.get("projectDisciplineIds")?.contains(approverId)) {
    return true;
  }

  // Check if the user has REPORTING PACKAGE view permissions
  let hasReportingPackageRead = userPermissions
    ?.get("project_disciplines")
    ?.some((i) => (i.getInPath("auth.policy_json.actions") || Im.List())?.toSet().has("READ_TRACKER_REF"));
  return hasReportingPackageRead;
};

const mapStateToProps = (state, ownProps) => {
  // Get the children on this row from the store
  let { projectId, tracker, rootRef, userPermissions } = ownProps;

  let rootRefId = rootRef.get("uid");
  let commitId = rootRef.get("latest_commit").get("uid");
  let trackerId = tracker.get("uid");
  let treeId = rootRef.getInPath("latest_commit.tree_root.uid");

  // There should not be multiple revisions of branches
  let subBranches = state.getInPath(`entities.commitBranches.commit.${commitId}.branch`) || Im.Map();
  let subRefs = Im.List();
  for (let branch of subBranches.valueSeq()) {
    let branchRefs = branch.get("byId") || Im.Map();
    for (let commitBranch of branchRefs.valueSeq()) {
      let subRefId = commitBranch.getInPath("target.ref");
      if (subRefId != rootRefId) {
        subRefs = subRefs.push(state.getInPath(`entities.refs.byId.${subRefId}`));
      }
    }
  }

  // Get the disciplines for this work package
  let disciplines = state.getInPath(`entities.projectObjects.byId.${projectId}.disciplines`) || Im.List();

  // Get the reporting periods for this project
  let projectReportingPeriods = state.getInPath(`entities.projectReportingPeriods.byId.${projectId}`);

  // Does user have permissions to see this level
  let isAllowedToSee = <ProjectPermission projectId={projectId} requiresAdmin={true} boolean={true} />;

  return {
    commitId,
    rootRefId,
    trackerId,
    treeId,
    subRefs,
    projectId,
    disciplines,
    projectReportingPeriods,
    isAllowedToSee,
  };
};
